import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";

import { utils, writeFileXLSX } from "xlsx";

// mui components
import { Box, Stack } from "@mui/material";

// mui icons
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";

// api slice
import { useGetPipelineMutation } from "../../features/pipeline/pipelineApiSlice";
import { useGetAdminPipelineMutation } from "../../features/admin/pipeline/pipelineApiSlice";
import { useGetAdminUnfilteredPipelineMutation } from "../../features/admin/pipeline/unfilteredLoanApiSlice";
import { useGetAePipelineMutation } from "../../features/admin/pipeline/aePipelineApiSlice";
import { useGetAmPipelineMutation } from "../../features/admin/pipeline/amPipelineApiSlice";
import { useGetPaPipelineMutation } from "../../features/admin/pipeline/paPipelineApiSlice";

// redux slice
import {
	selectChildOrganizationName,
	selectOrganizationName,
	selectUserDetails,
	selectSelectedOrganization,
} from "../../features/auth/authSlice";
import { useOrganizationId } from "../../features/auth/useOrganizationId";
import { selectImpersonatedUser } from "../../features/admin/impersonated-user/impersonatedUserSlice";

// custom components
import CustomLayout from "../../components/layout";
import CustomTable from "../../components/custom-table";
import Heading3 from "../../components/typography/heading-03";
import SecondaryButton from "../../components/buttons/secondary-button";

//helper utils
import { VERBIAGE_CONSTANTS } from "../../utils/verbiage.constants";
import { BROKER_ADMIN, COMPANY_ADMIN } from "../../utils/common-constants";

// custom modal
import LoaderModal from "../../components/modal/loader-modal";
import ErrorModal from "../../components/modal/error-modal";
import ConfirmationModal from "../../components/modal/confirmation-modal";
import CommanErrorModal from "../../components/modal/common-error-modal";
import { useErrorMessages } from "../../utils/error-messages.constants";

// custom styles
import styles from "./index.module.scss";

const Pipeline = () => {
	const { getErrorMessage } = useErrorMessages();
	const { org } = useParams();
	
	// Ensure organization ID is set for TPO-ORG-ID header
	useOrganizationId('pipeline');

	const navigate = useNavigate();
	const [loans, setLoans] = useState([]);
	const [loadingData, setLoadingData] = useState(false);
	const [loaderModal, setLoaderModal] = useState(loadingData);

	const [confirmModalVisible, setConfirmModalVisible] = useState(false);

	const handleOpenConfirmModal = () => {
		setConfirmModalVisible(true);
	};

	const handleCloseConfirmModal = () => {
		setConfirmModalVisible(false);
	};

	const handleSubmitConfirmModal = () => {
		navigate("/admin");
	};

	const [getPipeline, { isLoading: brokerLoading }] = useGetPipelineMutation();

	const [getAdminPipeline, { isLoading: adminLoading }] =
		useGetAdminPipelineMutation();

	const [getAdminUnfilteredPipeline, { isLoading: adminUnfilteredLoading }] =
		useGetAdminUnfilteredPipelineMutation();

	const [getAmPipeline, { isLoading: amPipelineLoading }] =
		useGetAmPipelineMutation();

	const [getAePipeline, { isLoading: aePipelineLoading }] =
		useGetAePipelineMutation();

	const [getPaPipeline, { isLoading: paPipelineLoading }] =
		useGetPaPipelineMutation();

	const [errorModalVisible, setErrorModalVisible] = useState(false);
	const [errorText, setErrorText] = useState("");

	// Common error modal state
	const [commonErrorModalOpen, setCommonErrorModalOpen] = useState(false);
	const [commonErrorData, setCommonErrorData] = useState(null);

	const handleOpenErrorModal = () => {
		setErrorModalVisible(true);
	};

	const handleCloseErrorModal = () => {
		setErrorModalVisible(false);
	};

	const handleOpenCommonErrorModal = (errorKey) => {
		const errorData = getErrorMessage(errorKey);
		if (errorData) {
			setCommonErrorData(errorData);
			setCommonErrorModalOpen(true);
		}
	};

	const handleCloseCommonErrorModal = () => {
		setCommonErrorModalOpen(false);
		setCommonErrorData(null);
	};

	const userDetails = useSelector(selectUserDetails);
	const impersonatedUser = useSelector(selectImpersonatedUser);
	const organizationName = useSelector(selectOrganizationName);
	const childOrganizationName = useSelector(selectChildOrganizationName);
	const selectedOrganization = useSelector(selectSelectedOrganization);

	// Use organization from URL parameter first, then Redux state, then fallback to original logic
	let currentOrgName;

	if (org && org !== "") {
		// Use organization from URL parameter (decoded)
		currentOrgName = decodeURIComponent(org);
	} else if (selectedOrganization && selectedOrganization !== "") {
		// Use organization selected from dropdown
		currentOrgName = selectedOrganization;
	} else {
		// Fall back to original logic
		// Handle case where organizationName might be an array (defensive programming)
		const safeOrganizationName = Array.isArray(organizationName) ? organizationName[0] : organizationName;
		
		if (userDetails?.user_roles === "admin" && impersonatedUser?.is_child_org) {
			currentOrgName = childOrganizationName;
		} else if (userDetails?.is_child_org || userDetails?.child_org_name !== "") {
			if (
				userDetails?.access_level === BROKER_ADMIN ||
				userDetails?.access_level === COMPANY_ADMIN
			) {
				currentOrgName = userDetails?.child_org_name;
			} else {
				currentOrgName = childOrganizationName;
			}
		} else {
			currentOrgName = safeOrganizationName;
		}
	}

	const shouldShow = userDetails?.user_roles?.includes("admin") && impersonatedUser?.email

	useEffect(() => {
		console.log("50 running pipeline API");

		async function getAllPipelineData() {
			console.log("67 user details:", userDetails);
			console.log("67 user roles:", userDetails?.user_roles);
			console.log(
                "67 user roles includes admin",
                userDetails?.user_roles?.includes("admin")
            );
			console.log("67 impersonated user:", impersonatedUser);
						console.log("67 impersonated user:", impersonatedUser?.email);

			if (
				userDetails?.user_roles?.includes("admin") === true &&
				impersonatedUser?.email !== undefined &&
				impersonatedUser?.email !== null &&
				impersonatedUser?.email !== ""
			) {
				console.log("28 org name:", impersonatedUser);
				try {
					const pipelineAdminData = await getAdminPipeline({
						brokerEmail: impersonatedUser?.email,
						loan_channel: impersonatedUser?.loan_channel,
						orgName: shouldShow ? impersonatedUser?.organization_name || impersonatedUser?.child_org_name : currentOrgName,
					}).unwrap();
					console.log("65 impersonated data:", pipelineAdminData?.data);
					setLoans(pipelineAdminData?.data);
				} catch (error) {
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
				return;
			} else if (
				(impersonatedUser?.email === undefined ||
					impersonatedUser?.email === null) &&
				userDetails?.user_roles?.includes("admin") === true
			) {
				try {
					const pipelineAdminLoanData =
						await getAdminUnfilteredPipeline().unwrap();
					console.log("65 admin data:", pipelineAdminLoanData?.data);
					setLoans(pipelineAdminLoanData?.data);
				} catch (error) {
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
				return;
			} else if (
				userDetails?.user_roles?.includes("manager") ||
				userDetails?.user_roles?.includes("AM")
			) {
				// account manager APIs
				console.log("150 pipeline manager");
				try {
					const pipelineData = await getAmPipeline().unwrap();
					console.log("65 account manager pipeline data:", pipelineData?.data);
					setLoans(pipelineData?.data);
				} catch (error) {
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
			} else if (
				userDetails?.user_roles?.includes("executive") ||
				userDetails?.user_roles?.includes("AE")
			) {
				// account executive APIs
				console.log("150 pipeline executive");
				try {
					const pipelineData = await getAePipeline().unwrap();
					console.log(
						"65 account executive pipeline data:",
						pipelineData?.data
					);
					setLoans(pipelineData?.data);
				} catch (error) {
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
			} else if (
				userDetails?.user_roles?.includes("assistant") ||
				userDetails?.user_roles?.includes("PA")
			) {
				// account assistant APIs
				console.log("150 pipeline assistant");
				try {
					const pipelineData = await getPaPipeline().unwrap();
					console.log(
						"65 account assistant pipeline data:",
						pipelineData?.data
					);
					setLoans(pipelineData?.data);
				} catch (error) {
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
			} else if (
				userDetails?.user_roles === undefined ||
				userDetails?.user_roles === "" ||
				userDetails?.user_roles?.includes("admin") === false
			) {
				console.log("Pipeline broker API call");
				console.log("API call details - currentOrgName:", currentOrgName);
				console.log("API call details - selectedOrganization:", selectedOrganization);
				
				if (!currentOrgName) {
					console.error("Cannot call pipeline API - no organization selected");
					handleOpenCommonErrorModal("PIPELINE_ERROR");
					return;
				}
				
				try {
					const brokerPipelineData = await getPipeline({
						orgName: currentOrgName,
						userDetails: userDetails,
					}).unwrap();
					console.log("65 broker data:", brokerPipelineData?.data);
					setLoans(brokerPipelineData?.data);
				} catch (error) {
					console.error("Pipeline API call failed:", error);
					console.error("Error details:", {
						currentOrgName,
						selectedOrganization,
						userOrganizations: userDetails?.organizations?.map(org => ({ name: org.name, id: org.id }))
					});
					handleOpenCommonErrorModal("PIPELINE_ERROR");
				}
				return;
			}
		}

		if (
			userDetails?.user_roles?.includes("admin") === true ||
			userDetails?.user_roles?.includes("executive") ||
			userDetails?.user_roles?.includes("AE") ||
			userDetails?.user_roles?.includes("manager") ||
			userDetails?.user_roles?.includes("AM") ||
			userDetails?.user_roles?.includes("PA") ||
			userDetails?.user_roles?.includes("assistant")
		) {
			getAllPipelineData();
		} else {
			if (
				currentOrgName !== null &&
				currentOrgName !== "null" &&
				currentOrgName !== undefined &&
				currentOrgName !== "undefined" &&
				currentOrgName !== ""
			) {
				getAllPipelineData();
			}
		}
	}, [userDetails, impersonatedUser, currentOrgName, org]);

	useEffect(() => {
		if (!userDetails?.user_roles?.includes("admin")) {
			setLoadingData(brokerLoading);
			setLoaderModal(brokerLoading);
		}
	}, [brokerLoading]);
	
	useEffect(() => {
		if (userDetails?.user_roles?.includes("admin")) {
			setLoadingData(adminLoading);
			setLoaderModal(adminLoading);
		}
	}, [adminLoading]);

	useEffect(() => {
		if (userDetails?.user_roles?.includes("admin")) {
			setLoadingData(adminUnfilteredLoading);
			setLoaderModal(adminUnfilteredLoading);
		}
	}, [adminUnfilteredLoading]);

	useEffect(() => {
		if (
			userDetails?.user_roles?.includes("manager") ||
			userDetails?.user_roles?.includes("AM")
		) {
			setLoadingData(amPipelineLoading);
			setLoaderModal(amPipelineLoading);
		}
	}, [amPipelineLoading]);

	useEffect(() => {
		if (
			userDetails?.user_roles?.includes("executive") ||
			userDetails?.user_roles?.includes("AE")
		) {
			setLoadingData(aePipelineLoading);
			setLoaderModal(aePipelineLoading);
		}
	}, [aePipelineLoading]);

	useEffect(() => {
		if (
			userDetails?.user_roles?.includes("assistant") ||
			userDetails?.user_roles?.includes("PA")
		) {
			setLoadingData(paPipelineLoading);
			setLoaderModal(paPipelineLoading);
		}
	}, [paPipelineLoading]);

	const pipelineColumns = [
		{ id: "number", label: "Loan Number", minWidth: 110 },
		{ id: "name", label: "Borrower Name", minWidth: 180 },
		{ id: "status", label: "Loan Status", minWidth: 140 },
		{ id: "start-date", label: "Start Date", minWidth: 120 },
		{ id: "address", label: "Property Address", minWidth: 400 },
		{ id: "program", label: "Loan Program", minWidth: 400 },
		{ id: "expiration-date", label: "Lock Expiration Date", minWidth: 140 },
		{ id: "folder", label: "Loan Folder", minWidth: 150 },
	];

	const adminPipelineColumns = [
		{ id: "number", label: "Loan Number", minWidth: 110 },
		{ id: "name", label: "Borrower Name", minWidth: 180 },
		{ id: "status", label: "Loan Status", minWidth: 140 },
		{ id: "start-date", label: "Start Date", minWidth: 120 },
		{ id: "address", label: "Property Address", minWidth: 400 },
		{ id: "program", label: "Loan Program", minWidth: 400 },
		{ id: "expiration-date", label: "Lock Expiration Date", minWidth: 140 },
		{ id: "folder", label: "Loan Folder", minWidth: 150 },
		{ id: "tpo", label: "TPO", minWidth: 150 },
	];

	const handleExportExcelClick = () => {
		const loanData = loans.map(({ loanGuid, fields }) => ({
			loanNumber: fields["Loan.LoanNumber"],
			startDate: fields["Fields.2025"]?.split(" ")[0],
			borrowerName: fields["Loan.BorrowerName"],
			propertyAddress:
				fields["Fields.URLA.X73"] +
				"," +
				fields["Fields.URLA.X75"] +
				"," +
				fields["Fields.12"] +
				"," +
				fields["Fields.14"],
			loanProgram: fields["Fields.1401"],
			lockExpirationDate: fields["Fields.762"]?.split(" ")[0],
			loanStatus: fields["Fields.Log.MS.CurrentMilestone"],
		}));

		const ws = utils.json_to_sheet(loanData);
		const wb = utils.book_new();
		utils.book_append_sheet(wb, ws, "Data");
		writeFileXLSX(wb, "Exported Excel.xlsx");
	};

	const breadcrumbData = [
		{
			label: "Home",
			path: "/home",
		},
		{
			label: "Loans",
			path: "/pipeline",
		},
	];

	return (
		<Box>
			<CustomLayout breadcrumb={breadcrumbData} disabledOverflow={true}>
				<Stack
					direction="row"
					className={styles.stackContainer}
					sx={{
						overflow: "hidden",
					}}
				>
					{/* pipeline table */}
					<Stack direction="column" className={styles.tableContainer}>
						<Stack
							direction="row"
							alignItems="center"
							justifyContent="space-between"
							className={styles.tableTitleContainer}
						>
							<Heading3 text="Pipeline" fontType="semibold" />

							<SecondaryButton
								text="Export to Excel"
								startIcon={
									<DownloadOutlinedIcon className={styles.downloadIcon} />
								}
								onClick={handleExportExcelClick}
							/>
						</Stack>

						<CustomTable
							columnData={
								((impersonatedUser?.email === undefined ||
									impersonatedUser?.email === null) &&
									userDetails?.user_roles?.includes("admin")) ||
								userDetails?.user_roles?.includes("executive") ||
								userDetails?.user_roles?.includes("manager") ||
								userDetails?.user_roles?.includes("AE") ||
								userDetails?.user_roles?.includes("AM") ||
								userDetails?.user_roles?.includes("PA") ||
								userDetails?.user_roles?.includes("assistant")
									? adminPipelineColumns
									: pipelineColumns
							}
							rowData={loans?.filter(
								(loan) =>
									loan?.fields["Loan.LoanFolder"] === "Pipeline" ||
									loan?.fields["Loan.LoanFolder"] ===
										"Portal - Not Submitted" ||
									loan?.fields["Loan.LoanFolder"] === "Funded" ||
									loan?.fields["Loan.LoanFolder"] === "Adverse Loans"
							)}
							tableType={
								((impersonatedUser?.email === undefined ||
									impersonatedUser?.email === null) &&
									userDetails?.user_roles?.includes("admin")) ||
								userDetails?.user_roles?.includes("executive") ||
								userDetails?.user_roles?.includes("manager") ||
								userDetails?.user_roles?.includes("AE") ||
								userDetails?.user_roles?.includes("AM") ||
								userDetails?.user_roles?.includes("PA") ||
								userDetails?.user_roles?.includes("assistant")
									? "admin-pipeline"
									: "pipeline"
							}
							isLoading={
								brokerLoading ||
								adminLoading ||
								adminUnfilteredLoading ||
								amPipelineLoading ||
								aePipelineLoading ||
								paPipelineLoading
							}
							setSortedData={setLoans}
							handleOpenConfirmModal={handleOpenConfirmModal}
						/>
					</Stack>
				</Stack>
			</CustomLayout>

			<LoaderModal open={loaderModal} />
			<ErrorModal
				open={errorModalVisible}
				text={errorText}
				handleClose={handleCloseErrorModal}
			/>
			<CommanErrorModal
				isOpen={commonErrorModalOpen}
				onClose={handleCloseCommonErrorModal}
				title={commonErrorData?.title}
				message={commonErrorData?.message}
				errorKey={commonErrorData?.error_key}
				errorCode={commonErrorData?.code}
				errorResponse={commonErrorData?.error_response}
			/>
			<ConfirmationModal
				open={confirmModalVisible}
				text={VERBIAGE_CONSTANTS.SIGN_IN_BROKER}
				confirmText="Sign In"
				handleConfirm={handleSubmitConfirmModal}
				closeText="Close"
				handleClose={handleCloseConfirmModal}
			/>
		</Box>
	);
};

export default Pipeline;
